import React from 'react';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { DropFileDiv } from './styles';

interface DropBoxProps {
  editorHeight?: number;
  applyDropBoxTopSpacing?: number;
}

const DropBox: React.FC<DropBoxProps> = ({ editorHeight = 98, applyDropBoxTopSpacing }) => {
  return (
    <>
      <DropFileDiv style={{ height: `${editorHeight}px` }} applyDropBoxTopSpacing={applyDropBoxTopSpacing}>
        <SVGIcon name='drop-file-icon' width='36' height='36' viewBox='0 0 36 36' />
        <span>Drop your files here</span>
      </DropFileDiv>
    </>
  );
};

export default DropBox;
